<template>
  <div class="home">
    <van-cell class="actValue" title="邀约访客">
      <span>
        <a @click="goHome">来访预约</a>
      </span>
    </van-cell>
    <p class="part_title">主访客信息</p>
    <common-input
      v-model.trim="dataFrom.name"
      :err-msg="nameErrMsg"
      display="false"
      :max="20"
      name="姓名"
      placeholder="请输入姓名"
      @inputBlured="checkName"
    />
    <van-cell class="van-cell--required van-field hasinput" title="性别">
      <van-radio-group v-model="dataFrom.gender" @change="$forceUpdate()">
        <van-radio name="MALE" @click="$forceUpdate()">男</van-radio>
        <van-radio name="FEMALE" @click="$forceUpdate()">女</van-radio>
      </van-radio-group>
    </van-cell>
    <common-input
      v-model.trim="dataFrom.phone"
      :err-msg="phonErrMsg"
      display="false"
      type="number"
      name="手机号"
      placeholder="请输入手机号"
      @inputBlured="checkPhone"
      @inputChanged="checkPhone"
    />
    <common-input
      v-for="item in extraFields"
      :key="item.id"
      v-model.trim="dataFrom[item.fieldName]"
      :required="item.must"
      :err-msg="item.msg"
      display="false"
      :name="item.displayName"
      :placeholder="`请输入${item.displayName}`"
      @inputChanged="() => checkFields(item, dataFrom[item.fieldName])"
    />
    <p class="part_title">来访事由及时间</p>
    <van-cell required class="actValue" title="来访事由">
      <span @click="showCause = true">{{ dataFrom.reason }}</span>
    </van-cell>
    <van-cell required class="actValue" title="来访楼层">
      <span @click="changeFloor">{{ dataFrom.floorName }}</span>
    </van-cell>
    <van-cell required class="actValue" title="来访时间">
      <span @click="showPicker = true">{{ dataFrom.visitDate }}</span>
    </van-cell>
    <van-cell required class="actValue" title="离访时间">
      <span @click="showTwoPicker =true">{{ dataFrom.endVisitDate }}</span>
    </van-cell>
    <van-cell required class="actValue" title="通行时效">
      <span @click="showOnce = true">{{ showOnceText }}</span>
      <!--      // dataFrom.once === undefined ? '' : (dataFrom.once ? '' : '')-->
    </van-cell>
    <ul v-if="dataFrom.retinues.length>0">
      <p class="part_title">陪同访客信息</p>
      <li v-for="(item,index) in dataFrom.retinues" :key="index" @click="onChange(index)">
        <van-cell :border="false" :title="item.name" :value="item.name">
          <template #default>
            <span style="color: #ff4d4f" @click="onDel(index)">删除</span>
          </template>
        </van-cell>
      </li>
    </ul>
    <van-button class="add_btn sub_btn" type="default" @click="onAdd">添加陪同访客</van-button>
    <van-button class="sub_btn" type="info" @click="onInvite">提交邀约申请</van-button>
    <div v-show="showCause" class="piker_wrap" @click="showCause = false">
      <ul class="piker_content" @click.stop>
        <li
          v-for="(item,index) in reasonList"
          :key="index"
          :class="{active:active==index}"
          @click="changeReason(item,index)"
        >{{ item }}</li>
      </ul>
      <div class="cancel" @click="onCancel">取消</div>
    </div>
    <van-dialog v-model="addDialog" class="teamdialog" :before-close="beforeClose" title="添加陪同访客" show-cancel-button>
      <common-input
        v-model.trim="teamFrom.name"
        :err-msg="teamNameErrMsg"
        display="false"
        name="姓名"
        placeholder="请输入陪同访客姓名"
      />
      <van-cell class="van-cell--required van-field hasinput" title="性别">
        <van-radio-group v-model="teamFrom.gender" @change="$forceUpdate()">
          <van-radio name="MALE" @click="$forceUpdate()">男</van-radio>
          <van-radio name="FEMALE" @click="$forceUpdate()">女</van-radio>
        </van-radio-group>
      </van-cell>
      <common-input
        v-model.trim="teamFrom.phone"
        :err-msg="teamPhoneErrMsg"
        display="false"
        type="number"
        name="手机号"
        placeholder="请输入陪同访客手机号"
      />
      <common-input
        v-for="item in teamExtraFields"
        :key="item.id"
        v-model.trim="teamFrom[item.fieldName]"
        :required="item.must"
        :err-msg="item.msg"
        display="false"
        :name="item.displayName"
        :placeholder="`请输入${item.displayName}`"
        @inputChanged="() => checkFields(item, teamFrom[item.fieldName])"
      />
    </van-dialog>
    <van-dialog v-model="showDialog" class="new—dialog" title="温馨提示" confirm-button-text="我知道了" message-align="left">
      <div class="van-dialog__message">
        <p>{{ visitorMsg.message }}，{{ visitorMsg.name }} 已登记于{{ visitorMsg.visitDate }}访问 {{ visitorMsg.beVisitCompanyName }} {{ visitorMsg.beVisitStaffName }}，当前状态:{{ visitorMsg.visitorStatusName }}</p>
        <p class="tips">请联系该访客结束（取消）上次访问后再邀约，谢谢</p>
      </div>
    </van-dialog>
    <van-popup v-model="showPicker" position="bottom" :style="{ height: '50%' }">
      <van-datetime-picker
        v-model="currentDate"
        type="datetime"
        :min-date="minDate"
        :formatter="formatter"
        @confirm="timeConfirm"
        @cancel="showPicker =false"
      />
    </van-popup>
    <van-popup v-model="showOnce" position="bottom" :style="{ height: '40%' }">
      <van-picker
        title="通行时效"
        show-toolbar
        value-key="text"
        :default-index="0"
        :columns="columns"
        @confirm="onConfirm"
        @cancel="showOnce = false"
      />
    </van-popup>
    <van-popup v-model="showTwoPicker" position="bottom" :style="{ height: '50%' }">
      <van-datetime-picker
        v-model="nextTwoDate"
        type="datetime"
        :min-date="minDate"
        :max-date="maxDate"
        :formatter="formatter"
        @confirm="timeTwoConfirm"
        @cancel="showTwoPicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
import moment from 'moment';
import commonInput from '@/components/commonInput';
import { Invite, getReasons } from '@/api/home';
import { GetStaffInfo } from '@/api/user';
export default {
  name: 'Invite',
  components: {
    commonInput
  },
  data() {
    return {
      active: 0,
      reasonList: [],
      showDialog: false,
      showTwoPicker: false,
      changeIndex: -1,
      visitorMsg: {},
      showOnce: false,
      limitDays: 30,
      clickFlag: false,
      fromHistoryInfo: {},
      dataFrom: {
        once: true,
        gender: 'MALE',
        accessDays: 1,
        reason: '',
        visitDate: '',
        carNumber: '',
        name: '',
        phone: '',
        retinues: [],
        floorName: '',
        beVisitFloorId: ''
      },
      teamFrom: {
        name: '',
        gender: 'MALE',
        phone: '',
        carNumber: ''
      },
      copyTeamFrom: {
        name: '',
        phone: '',
        gender: 'MALE',
        carNumber: ''
      },
      copyTeamFromIndex: null,
      showPicker: false,
      showCause: false,
      minDate: new Date(),
      maxDate: new Date(),
      currentDate: '',
      addDialog: false,
      datetime: '',
      nameErrMsg: '', // 姓名输入提示
      phonErrMsg: '', // 手机号校验提示
      teamPhoneErrMsg: '', // 陪同访客手机号提示
      teamNameErrMsg: '', // 陪同访客姓名提示
      columns: [],
      extraFields: [],
      teamExtraFields: [],
      showOnceText: '',
      nextTwoDate: ''
    };
  },
  computed: {
    dataRange() {
      let needVal = '';
      let needless = '';
      needVal = Number(Boolean(this.dataFrom.name)) + Number(Boolean(this.dataFrom.phone));
      needless = Number(Boolean(this.nameErrMsg)) + Number(Boolean(this.phonErrMsg));
      return {
        needVal,
        needless
      };
    }
  },
  watch: {
    dataRange(val) {
      if (Number(val.needVal) === 2 && Number(val.needless) === 0) {
        this.clickFlag = true;
      } else {
        this.clickFlag = false;
      }
    },
    'dataFrom.once'(val) {
      if (val === undefined) {
        this.showOnceText = this.columns[0] ? this.columns[0].text : '';
      }
      let trueText = '';
      let falseText = '';
      this.columns.forEach(item => {
        if (item.value) {
          trueText = item.text;
        } else {
          falseText = item.text;
        }
      });
      if (val) {
        this.showOnceText = trueText;
      } else {
        this.showOnceText = falseText;
      }
    }
  },
  created() {
    this.getReasonList();
    const { inviteInfo } = this.$route.params;
    if (inviteInfo) {
      const info = JSON.parse(inviteInfo);
      const { retinues } = info;
      this.fromHistoryInfo = info;
      this.dataFrom = info;
      this.dataFrom.floorName = info.floorName;
      this.dataFrom.accessDays = 1;
      this.dataFrom.gender = info.gender || 'MALE';
      retinues.forEach(item => {
        item.gender = item.gender || 'MALE';
      });
      this.teamFrom = retinues;
      const data = {
        id: info.beVisitFloorId,
        parentId: info.beVisitEdificeId,
        parentName: info.beVisitEdificeName,
        name: info.beVisitFloorName
      };
      this.$store.dispatch('setFloorInfo', { data: data });
    } else {
      this.dataFrom = this.$store.state.inviteData;
      this.dataFrom.gender = 'MALE';
      this.getStaffInfo();
    }
    this.setTime();
  },
  methods: {
    goHome() {
      this.$router.push({ name: 'home' });
      const dataFrom = {
        once: true,
        accessDays: 1,
        reason: '',
        visitDate: '',
        carNumber: '',
        name: '',
        phone: '',
        retinues: [],
        floorName: '',
        beVisitFloorId: ''
      };
      this.$store.dispatch('setFloorInfo', { data: {}});
      this.$store.dispatch('setInviteData', { data: dataFrom });
    },
    filter(type, options) {
      if (type === 'minute') {
        return options.filter(option => option % 1 === 0);
      } else {
        return options;
      }
    },
    formatter(type, value) {
      switch (type) {
        case 'year':
          value = `${value}年`;
          break;
        case 'month':
          value = `${value}月`;
          break;
        case 'day':
          value = `${value}日`;
          break;
        case 'hour':
          value = `${value}时`;
          break;
        case 'minute':
          value = `${value}分`;
          break;
      }
      return value;
    },
    getStaffInfo() {
      GetStaffInfo({}).then(res => {
        const { edifice, floor, floorId, edificeId } = res.data;
        const info = this.$store.state.floorInfo;
        if (info.id) {
          this.$store.dispatch('setFloorInfo', { data: info });
          this.dataFrom.floorName = info.parentName + info.name;
          this.dataFrom.beVisitFloorId = info.id;
        } else {
          this.dataFrom.floorName = edifice + floor;
          info.id = floorId;
          info.parentId = edificeId;
          info.parentName = edifice;
          info.name = floor;
          this.dataFrom.beVisitFloorId = floorId;
          this.$store.dispatch('setFloorInfo', { data: info });
        }
      });
    },
    // 设置默认时间为当前时间的下一个整点
    setTime() {
      const nextHour = new Date();
      nextHour.setHours(nextHour.getHours() + 1, 0, 0, 0);
      const nextTwoHour = new Date(nextHour);
      nextTwoHour.setHours(nextTwoHour.getHours() + 1);
      this.dataFrom.visitDate = this.formatDate(nextHour);
      this.dataFrom.endVisitDate = this.formatDate(nextTwoHour);
      this.currentDate = nextHour;
      this.nextTwoDate = nextTwoHour;
      this.minDate = new Date();
    },
    timeConfirm(val) {
      const formatDateForIOS = (dateString) => {
        // 确保日期格式为 yyyy-MM-ddTHH:mm:ss，以兼容 iOS
        return dateString.replace(/-/g, '-').replace(' ', 'T');
      };

      const visitDateFormatted = formatDateForIOS(this.formatDate(val)); // 确保 visitDate 的格式为 yyyy-MM-ddTHH:mm:ss
      const visitDate = new Date(visitDateFormatted); // 格式化后的 visitDate

      // 检查是否早于当前时间
      if (visitDate.getTime() < new Date().getTime()) {
        this.$toast({
          message: '来访时间不能在当前时间之前'
        });
        return;
      }

      this.dataFrom.visitDate = this.formatDate(val);
      this.showPicker = false;

      // 格式化 endVisitDate
      const endVisitDateFormatted = formatDateForIOS(this.dataFrom.endVisitDate);
      const endVisitDate = new Date(endVisitDateFormatted);

      // 比较 visitDate 和 endVisitDate
      if (visitDate >= endVisitDate) {
        const nextHour = new Date(val);
        nextHour.setHours(nextHour.getHours() + 1);
        this.dataFrom.endVisitDate = this.formatDate(nextHour);
        this.nextTwoDate = nextHour;
      }

      // 计算 maxDate
      this.maxDate = new Date(visitDate.getTime() + this.limitDays * 24 * 60 * 60 * 1000);
    },
    timeTwoConfirm(val) {
      const formatDateForIOS = (dateString) => {
        // 确保日期格式为 yyyy-MM-ddTHH:mm:ss，以兼容 iOS
        return dateString.replace(/-/g, '-').replace(' ', 'T');
      };

      // 格式化 visitDate 和 endVisitDate
      const visitDateFormatted = formatDateForIOS(this.dataFrom.visitDate);
      const visitDate = new Date(visitDateFormatted);

      const endVisitDateFormatted = formatDateForIOS(this.formatDate(val));
      const endVisitDate = new Date(endVisitDateFormatted);

      // 判断离访时间是否早于来访时间
      if (visitDate.getTime() >= endVisitDate.getTime()) {
        this.$toast({
          message: '离访时间不能在来访时间之前'
        });
        return;
      }

      // 更新离访时间
      this.dataFrom.endVisitDate = this.formatDate(val);
      this.showTwoPicker = false;
    },
    formatDate(date) {
      const y = date.getFullYear();
      const m = (date.getMonth() + 1).toString().padStart(2, '0');
      const d = date.getDate().toString().padStart(2, '0');
      const h = date.getHours().toString().padStart(2, '0');
      const min = date.getMinutes().toString().padStart(2, '0');
      return `${y}-${m}-${d} ${h}:${min}`;
    },
    getReasonList() {
      const data = {};
      getReasons(data).then(res => {
        res.data.extraFields.APPOINTMENT && res.data.extraFields.APPOINTMENT.forEach(item => {
          item.msg = '';
        });
        this.extraFields = JSON.parse(JSON.stringify(res.data.extraFields.APPOINTMENT || []));
        this.teamExtraFields = JSON.parse(JSON.stringify(res.data.extraFields.APPOINTMENT || []));
        const accessTypes = Object.keys(res.data.accessTypes);
        const columns = [];
        accessTypes.forEach(item => {
          const data = { text: item, value: res.data.accessTypes[item] };
          columns.push(data);
        });
        this.columns = columns;
        this.showOnceText = this.columns[0].text;
        this.dataFrom.once = this.columns[0].value;
        this.limitDays = res.data.limitDays;
        this.maxDate = new Date(new Date().getTime() + this.limitDays * 24 * 60 * 60 * 1000);
        this.reasonList = res.data.reasons;
        const { inviteInfo } = this.$route.params;
        if (inviteInfo) {
          const info = JSON.parse(inviteInfo);
          if (this.reasonList.includes(info.reason)) {
            this.dataFrom.reason = info.reason;
          } else {
            this.dataFrom.reason = this.reasonList[0];
          }
        } else {
          this.dataFrom.reason = this.dataFrom.reason || this.reasonList[0];
        }
      });
    },
    onCancel() {
      this.showCause = false;
    },
    onAdd() {
      this.addDialog = true;
      this.changeIndex = -1;
      this.teamFrom = {
        name: '',
        phone: '',
        gender: 'MALE',
        carNumber: ''
      };
      this.teamPhoneErrMsg = '';
      this.teamNameErrMsg = '';
    },
    beforeClose(action, done) {
      if (action === 'confirm') {
        if (!this.checkTeamName() && !this.checkTeamPhone()) {
          let isFail = false;
          this.teamExtraFields.forEach(item => {
            if (!this.checkFields(item, this.teamFrom[item.fieldName])) {
              isFail = true;
            }
          });
          if (!isFail) {
            if (this.changeIndex === -1) {
              this.dataFrom.retinues.push(this.teamFrom);
            } else {
              this.dataFrom.retinues[this.changeIndex] = this.teamFrom;
            }
            done();
          } else {
            done(false);
          }
        } else {
          done(false);
        }
      } else if (action === 'cancel') {
        if (typeof this.copyTeamFromIndex === 'number') {
          this.dataFrom.retinues[this.copyTeamFromIndex] = this.copyTeamFrom;
        }
        done(); // 关闭
      }
    },
    onDel(index) {
      this.dataFrom.retinues.splice(index, 1);
    },
    onConfirm(e) {
      this.showOnce = false;
      this.dataFrom.once = e.value;
    },
    onInvite() {
      if (this.checkName() && this.checkPhone()) {
        let isFail = false;
        this.extraFields.forEach(item => {
          if (!this.checkFields(item, this.dataFrom[item.fieldName])) {
            isFail = true;
          }
        });
        if (!isFail) {
          Invite(this.dataFrom).then(res => {
            if (res.code === 200) {
              this.$router.push({ path: '/inviteSuc', query: { id: res.data }});
              const dataFrom = {
                once: true,
                accessDays: 1,
                reason: '',
                visitDate: '',
                carNumber: '',
                name: '',
                phone: '',
                retinues: [],
                floorName: '',
                beVisitFloorId: ''
              };
              this.$store.dispatch('setInviteData', { data: dataFrom });
            } else if (res.code === 50001) {
              this.visitorMsg = res.data;
              this.visitorMsg.message = res.message;
              this.showDialog = true;
              this.clickFlag = true;
            } else {
              this.$dialog.alert({
                title: '温馨提示',
                message: res.message,
                confirmButtonText: '我知道了'
              });
              this.clickFlag = true;
            }
          }).catch(_ => {
          });
        }
      }
    },
    checkPhone() {
      let phone;
      if (this.dataFrom.phone == '') {
        phone = false;
        this.phonErrMsg = '请输入手机号';
      } else if (!(/^1[3456789]\d{9}$/.test(this.dataFrom.phone))) {
        this.phonErrMsg = '手机号格式错误，请检查';
        phone = false;
      } else {
        this.phonErrMsg = '';
        phone = true;
      }
      return phone;
    },
    checkTeamPhone() {
      if (this.teamFrom.phone === '') {
        this.teamPhoneErrMsg = '请输入正确格式的手机号';
      } else if (!(/^1[3456789]\d{9}$/.test(this.teamFrom.phone))) {
        this.teamPhoneErrMsg = '手机号格式错误，请检查';
      } else {
        this.teamPhoneErrMsg = '';
      }
      return this.teamPhoneErrMsg;
    },
    checkTeamName() {
      if (this.teamFrom.name == '') {
        this.teamNameErrMsg = '请输入姓名';
      } else {
        this.teamNameErrMsg = '';
      }
      return this.teamNameErrMsg;
    },
    checkName() {
      let name;
      if (this.dataFrom.name === '') {
        name = false;
        this.nameErrMsg = '请输入姓名';
      } else {
        this.nameErrMsg = '';
        name = true;
      }
      return name;
    },
    checkFields(e, val) {
      if (e.must) {
        if (val === '') {
          e.msg = `请输入${e.displayName}`;
          return false;
        } else {
          e.msg = '';
          return true;
        }
      } else {
        return true;
      }
    },
    changeReason(item, i) {
      this.active = i;
      this.dataFrom.reason = item;
      this.showCause = false;
    },
    onChange(index) {
      this.changeIndex = index;
      this.teamFrom = this.dataFrom.retinues[index];
      this.copyTeamFrom = JSON.parse(JSON.stringify(this.dataFrom.retinues[index]));
      this.copyTeamFromIndex = index;
      this.teamPhoneErrMsg = '';
      this.teamNameErrMsg = '';
      this.addDialog = true;
    },
    changeFloor() {
      this.$router.push({ name: 'changeFloor' });
      this.$store.dispatch('setInviteData', { data: this.dataFrom });
    }
  }

};
</script>

<style lang="less" scoped>
.van-cell {
  flex-wrap: wrap;
}
@import '../style/home';
</style>
